export const ALL_USER_PROFILE_REQUEST = "allUser/allUserProfileRequest";
export const ALL_USER_PROFILE_SUCCESS = "allUser/allUserProfileSuccess";
export const ALL_USER_PROFILE_ERROR = "allUser/allUserProfileError";